import React from 'react';
import {BJ_AFREECATV_DOMAIN} from 'constants/config';
import {getLoginId} from 'lib/utils';
import Dim from 'components/common/Dim';
import {t} from 'lib/i18n';

interface ILoading {
  text?: string;
  isBtn?: boolean;
}

/**
 * 로딩 컴포넌트
 * @param text 로딩 시, 출력할 메시지
 * @param isBtn 링크 이동 버튼 추가 여부
 */
const Loading = ({text, isBtn}: ILoading) => {
  const loginId = getLoginId(); // 로그인 ID

  return (
    <>
      <Dim />
      <div className='loading_animation'>
        <span></span>
        <p>{text}</p>
        {isBtn && (
          <a href={`${BJ_AFREECATV_DOMAIN}/${loginId}`}>{t('방송국 이동')}</a>
        )}
      </div>
    </>
  );
};

Loading.defaultProps = {
  text: '',
  isBtn: false,
};

export default Loading;
